import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient.js';
import NewsRow from './NewsRow.jsx';
import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import ConferenceDropdown from '../../Forms/ConferenceDropdown';
import Loader from '../../assets/tools/Loder/loader';
import { DataTable, PageHeader, PageToolbar } from '../../componants/Workspace';

const News = () => {
  const { SetNotification } = useStateContext();
  const [news, setNews] = useState([]);
  const [filteredNews, setFilteredNews] = useState([]);
  const [loading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [newsPerPage] = useState(5);
  const [conferenceId, setConferenceId] = useState(null);
  const [language, setLang] = useState('EN');
  const [onDelete , setOnDelete] = useState (false) ; 
  const fetchData = async () => {
    try {
      const response = await AxiosClient.get('/news');
      const _news = response.data.news;
      setNews(_news);
      setIsLoading(false);
    } catch (error) {
      SetNotification('Error fetching data', 'danger');
    }
  };

  useEffect(() => {
    fetchData();
  }, [onDelete]);

  useEffect(() => {
    const filterNews = () => {
      let filtered = news;

      if (conferenceId) {
        filtered = filtered.filter((newsItem) => newsItem.conference_id === conferenceId);
      }

      if (language) {
        filtered = filtered.filter((newsItem) => newsItem.lang === language);
      }

      setFilteredNews(filtered);
    };

    filterNews();
  }, [news, conferenceId, language]);

  const indexOfLastNews = currentPage * newsPerPage;
  const indexOfFirstNews = indexOfLastNews - newsPerPage;
  const currentNews = filteredNews.slice(indexOfFirstNews, indexOfLastNews);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <PageHeader
        title="News"
        description="Publish and manage event announcements."
        actions={(
          <Link className="btn btn-primary" to="./Add">
            <i className="material-icons" aria-hidden="true">add</i>
            Add article
          </Link>
        )}
      />

      <PageToolbar
        filters={(
          <>
            <ConferenceDropdown conferenceId={conferenceId} setConferenceId={setConferenceId} />
            <div className="workspace-filter-group">
              <span className="workspace-filter-group__label">Language</span>
              <div className="workspace-segmented" role="group" aria-label="Filter news by language">
                {[
                  ['EN', 'English'],
                  ['AR', 'Arabic'],
                ].map(([code, label]) => (
                  <button
                    key={code}
                    type="button"
                    className={`btn ${language === code ? 'btn-primary' : 'btn-outline-secondary'}`}
                    onClick={() => setLang(code)}
                    aria-pressed={language === code}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>
          </>
        )}
      />

      {loading ? (
        <div className="workspace-loading"><Loader label="Loading news..." /></div>
      ) : (
        <DataTable className="table-fixed">
          <thead>
            <tr>
              <th>Title</th>
              <th></th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentNews.length > 0 ? currentNews.map((newsItem) => (
              <NewsRow key={newsItem.id} title={newsItem.title} id={newsItem.id} setOnDelete={setOnDelete} />
            )) : (
              <tr>
                <td colSpan="3" className="workspace-empty">No articles available for these filters.</td>
              </tr>
            )}
          </tbody>
        </DataTable>
      )}

      {!loading && filteredNews.length > newsPerPage && (
        <nav className="workspace-pagination" aria-label="News pages">
          <ul className="pagination mb-0">
            {Array.from({ length: Math.ceil(filteredNews.length / newsPerPage) }).map((_, index) => (
              <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                <button className="page-link" onClick={() => paginate(index + 1)} aria-current={currentPage === index + 1 ? 'page' : undefined}>
                  {index + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </>
  );
};

export default News;
